// extracted by mini-css-extract-plugin
export default {"root":"Header-module_root__KTCPs","title":"Header-module_title__k0ptD"};